<div class="box1">
  Wgraj z dysku
  @if (!(isUploading$ | async)) {
    <input
      type="file"
      #me
      (change)="uploadFromDisk(me)"
      [accept]="acceptedFormats.join(',')"
      />
  }
  @if (isUploading$ | async) {
    <mat-progress-bar
      mode="query"
    ></mat-progress-bar>
  }
</div>
<div class="box2" (click)="uploadFromZalamo()">
  Wgraj z Zalamo
  @if (isFromZalamoCoping$ | async) {
    <mat-progress-bar
      mode="query"
    ></mat-progress-bar>
  }
</div>
<div class="cancel">
  @if (isPhonePortrait$ | async) {
    <lib-button lg>ANULUJ</lib-button>
  }
</div>
